import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import style from './index.module.scss'

const Breadcrumb = ({ items, className }) => (
  <div className={classNames(style.breadcrumb, className)}>
    <div className={style.breadcrumbItems}>
      {items
        .map((item, index) =>
          item.link ? (
            <Link
              key={`item-${index}`}
              className={style.item}
              to={item.link}
              onClick={item.onClick}
            >
              {item.value}
            </Link>
          ) : (
            <span key={`item-${index}`} className={style.item}>
              {item.value}
            </span>
          )
        )
        .reduce((prev, curr, index) => [
          prev,
          <span key={index} className={style.separator} />,
          curr,
        ])}
    </div>
  </div>
)

Breadcrumb.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
}

export default Breadcrumb
